import { ADD_SUPPLIER_DESTINATION_MAPPING_FAILURE, ADD_SUPPLIER_DESTINATION_MAPPING_REQUEST, ADD_SUPPLIER_DESTINATION_MAPPING_RESET, ADD_SUPPLIER_DESTINATION_MAPPING_SUCCESS } from "redux/actions/action-type"


const initialState = {
    isAddSupplierDestinationMappingLoading: false,
    isAddSupplierDestinationMappingSuccess: false,
    isAddSupplierDestinationMappingFail: false,
    addSupplierDestinationMappingResponse: {}
}

export const addSupplierDestinationMappingReducer = (state = initialState, { type, addSupplierDestinationMappingResponse }) => {
    switch (type) {
        case ADD_SUPPLIER_DESTINATION_MAPPING_REQUEST:
            return {
                ...state,
                isAddSupplierDestinationMappingLoading: true,
                isAddSupplierDestinationMappingSuccess: false,
                isAddSupplierDestinationMappingFail: false
            }
        case ADD_SUPPLIER_DESTINATION_MAPPING_SUCCESS:
            return {
                ...state,
                addSupplierDestinationMappingResponse: addSupplierDestinationMappingResponse,
                isAddSupplierDestinationMappingLoading: false,
                isAddSupplierDestinationMappingSuccess: true,
                isAddSupplierDestinationMappingFail: false
            }
        case ADD_SUPPLIER_DESTINATION_MAPPING_FAILURE:
            return {
                ...state,
                addSupplierDestinationMappingResponse: addSupplierDestinationMappingResponse,
                isAddSupplierDestinationMappingLoading: false,
                isAddSupplierDestinationMappingSuccess: false,
                isAddSupplierDestinationMappingFail: true
            }
        case ADD_SUPPLIER_DESTINATION_MAPPING_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}